<template>
  <div class="homePage_wrap" @scroll="scorllHandle($event)">
      <!-- 轮播图 -->
      <div class="top-carousel">
        <div id="carousel-example-generic" class="carousel slide" data-ride="carousel" >

          <!-- Wrapper for slides -->
          <div class="carousel-inner" role="listbox" >
            <div class="item active">
                <!-- <img :src="item" alt="" />
                 -->
                <img src="../../assets/images/index/lunbo1.png" alt="" />
            </div>
            <div class="item">
                <img src="../../assets/images/index/lunbo2.png" alt="" />
            </div>
          </div>

          <!-- Controls -->
          <a class="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>

      <!-- 关于公司 -->
      <div class="about">
        <div class="title">
          <div>
            关于公司
          </div>
          <div class="yinwen">
            CONTACT US
          </div>
          <img src="../../assets/images/index/shenglue.png" alt="">
        </div>
        <div class="content">
          <p>
           上海钰狮科技有限公司，简称“钰狮科技”，是由中国最大的黄金珠宝首饰产业集团之一的德诚珠宝集团有限公司于2020年创立的一家科技公司。钰狮专注于黄金珠宝行业的科技技术创新。深耕黄金珠宝行业数字化转型，聚产销研全生态科技革命，涵盖产销研信息化、数字化、智能化科技公司。
          </p>
          <p>
            钰狮科技具备黄金珠宝行业流通端智能设备、生态信息化，数字化软件及云服务等全方位自主研发和服务能力，为行业客户提供行业领先的互联网及移动互联网信息化应用产品、数字化产品、流通端智能设备及行业全生态信息化、数字化、智能化解决方案引领供商。
          </p>
          <p>
            钰狮科技以技术创新为驱动，以产品为利器，优质服务为准绳。钰狮科技为行业客户量身打造更符合企业特点的解决方案；用更成熟的方案解决企业痛点，用专业的团队为企业提供更满意的服务。

          </p>
          <p>
            钰狮科技做黄金珠宝行业数字化转型领域对的事，难的事，被时间证明的事。
          </p>
        </div>
      </div>
      <div class="about">
        <div class="title">
          <div>
            公司地点
          </div>
          <div class="yinwen">
            Company address
          </div>
          <img src="../../assets/images/index/shenglue.png" alt="">
        </div>
      </div>
    <div class="map">
      <baidu-map class="map1" :center="center" :zoom="zoom" @ready="handler" @click="getClickInfo" :scroll-wheel-zoom='true'>
      </baidu-map>
    </div>
     <div class="shop container-fluid">
        <!-- 回顶箭头 -->
       <div class="animation-bg-view">
          <div  class="animation">
            <img @click="gotop" src="../../assets/images/pzbz/icon.png" alt="">
          </div>
        </div>
       </div>


  </div>
</template>

<script>
  import userEqu  from '../../assets/Device.js'
  import router from "../../application/router";
  // import {
  //   index
  // } from "../../assets/game_data";
  // import {
  //   games
  // } from "../../assets/game_data";
  export default {
    data() {
      return {
        topimgsrc:[],//顶部banner数组
        contentimgsrc:[],//内容banner数组
        cellList:[], //新闻列表
        // gamesData: [],
        center: {lng: 121.44798, lat: 31.303572},
        zoom: 1,
        // initData: index,
        // langIndex: Number(localStorage.getItem("currentLangIndex") || "2"), //语言类型index
        changeNum: [],
        timeID: "",
        myHeight:515,
        isMobile:false,
      };
    },
    watch: {
      // "$store.state.langPack": function() {
      //   this.langIndex = Number(localStorage.getItem("currentLangIndex"));
      //   // this.initData = {};
      //   // this.initData = index; //变动数据驱动type语言切换
      // }
    },
    methods: {
      _isMobile() {
      	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      	 return flag;
      },
      getInfo() {
          let res = this.$http.getbanner();
          res.then((result)=>{
            result.result.forEach((item,index)=>{
                this.topimgsrc.push(this.$config.baseImgUrl()+'/'+item)
            })
            console.log(result,"nihao")

          }).catch((err)=>{
            // console.log(err);
          });
      },
      //获取首页中部轮播图
      getCard(){
          let ress = this.$http.getCard()
          ress.then(res=>{
            res.result.forEach((item,index)=>{
                this.contentimgsrc.unshift(this.$config.baseImgUrl()+'/'+item)
                console.log(item)//图片地址
            })
            // console.log(res,"xxx")
          }).catch(err=>{
            // console.log(err,"www")
          })
      },
      scorllHandle(event) {
        // console.log(1234);
      },

    handler ({BMap, map}) {
      var point = new BMap.Point(121.44798, 31.303572)
      map.centerAndZoom(point, 13)
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', Color: 'Red', fillColor: '#f03' })
      map.addOverlay(circle)
    },
    getClickInfo (e) {
      console.log(e.point.lng)
      console.log(e.point.lat)
      // this.center.lng = e.point.lng
      // this.center.lat = e.point.lat
    },
      //返回顶部方法
      gotop() {
        let top = document.documentElement.scrollTop || document.body.scrollTop; //兼容ie
        // 点击返回顶部
        const timeTop = setInterval(() => {
          document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
          if (top <= 0) {
            clearInterval(timeTop);
          }
        }, 10);
      },
      goabout(){
        router.push({path:'/about'})
      },
      getimgurl(){

      },
    getNewsList(kind) {
        let param = {
          "filters": {
            "typeName": '珠宝课堂' // 新闻的标题
          },
          "page": 1, // 分页参数页码
          "size": 10 // 分页参数页面数据条数
        }

        let res = this.$http.getNewsList(param)
        res.then(res => {
            this.cellList = res.result.records;
            console.log(this.cellList)
        }).catch(err => {
          window.console.log(err)
          // console.log(err, "错误信息")
        })

      },
    },
    created() {

      // console.log(userEqu,"设备类型");

      if(userEqu.isAndroid||userEqu.isPhone){
        this.myHeight=249
      }else if(userEqu.isPc&&userEqu.isTablet==false){
        this.myHeight=515
      }else if(userEqu.isPc&&userEqu.isTablet){
        this.myHeight=360
      }
      if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        this.isMobile = true // 手机端
      } else {
        this.isMobile = false // alert('PC端')
      }
      this.getNewsList()
      // for (let key in games) {
      //   let count = '';
      //   let unit = '';
      //   for (let i = 0; i < games[key].downloads.length; i++) {
      //     if (/\d/.test(games[key].downloads[i])) {
      //       count += games[key].downloads[i];
      //     } else {
      //       unit += games[key].downloads[i];
      //     }
      //   }
      //   this.gamesData.push(games[key]);
      //   this.changeNum.push({
      //     count: count,
      //     unit: unit
      //   });
      // }
      this.getInfo();
      this.getCard()
      $(function(){
          $('#carousel-example-generic').carousel({interval:5000});});
    },
    mounted() {
      if (this._isMobile()) {
        this.myHeight=249
      } else {
        this.myHeight=515
      }
    }
  }
</script>

<style lang="less" scoped>
  @screen-xs-min:768px;
  @screen-md-min:992px;
  @screen-lg-min:1200px;

  .carousel-control.left{ background-image:none;}
  .carousel-control.right{ background-image:none;}
  .homePage_wrap {
    max-width: 1920px;
    margin: 0 auto;
    @media screen and(min-width: 770px) {
      margin-top: 80px;
    }
    @media screen and(max-width: 770px) {
      margin-top: 50px;
    }

    // 轮播图
    background-color: #FFF;
    .top-carousel {
      max-width: 1980px;
      margin: 0 auto;
    }
    }
    .about {
        .title{
          font-size: 35px;
          font-weight: 300;
          margin-top: 100px;
          color: #000000;
          @media screen and(max-width:1720px){
            font-size: 32px;
            margin-top: 30px;
          }
          @media screen and(max-width:1640px){
            font-size: 30px;
            margin-top: 30px;
          }
          @media screen and(max-width:1520px){
            font-size: 28px;
            margin-top: 30px;
          }
          @media screen and(max-width:1380px){
            font-size: 26px;
            margin-top: 30px;
          }
          @media screen and(max-width:1200px){
            font-size: 24px;
            margin-top: 30px;
          }
          @media screen and(max-width:1180px){
            font-size: 22px;
            margin-top: 30px;
          }
          @media screen and(max-width:1024px){
            font-size: 20px;
            margin-top: 25px;
          }
          @media screen and(max-width:1005px){
            width: 100%;
            font-size: 20px;
            margin-top: 30px;
          }
          @media screen and(max-width:768px){
            width: 100%;
            font-size: 20px;
            margin-top: 27px;
          }
          @media screen and(max-width:540px){
            font-size: 20px;
            margin-top: 15px;
          }
          .yinwen{
            color: #999999;
            font-size: 24px;
            @media screen and(max-width:1200px){
              font-size: 18px;
            }
            @media screen and(max-width:768px){
              font-size: 15px;
            }
          }
          img{
            width: 110px;
            // margin-bottom: 60px;
            margin: 30px 0 40px 0;
            @media screen and(max-width:1200px){
              width: 90px;
              margin: 15px 0 30px 0;
            }
            @media screen and(max-width:768px){
              width: 60px;
              margin: 5px 0 10px 0;
            }
          }
        }
        .content{
          padding: 0 20px;
          font-size: 30px;
          font-weight: 300;
          margin-top: 44px;
          width: 80%;
          margin: 0 auto;
          // color: #666666;
          @media screen and(max-width:1720px){
            width: 80%;
            font-size: 28px;
            margin-top: 30px;
          }
          @media screen and(max-width:1640px){
            width: 80%;
            font-size: 26px;
            margin-top: 30px;
          }
          @media screen and(max-width:1520px){
            width: 80%;
            font-size: 24px;
            margin-top: 30px;
          }
          @media screen and(max-width:1380px){
            width: 80%;
            font-size: 22px;
            margin-top: 30px;
          }
          @media screen and(max-width:1200px){
            width: 80%;
            font-size: 20px;
            margin-top: 30px;
          }
          @media screen and(max-width:1180px){
            width: 80%;
            font-size: 18px;
            margin-top: 30px;
          }
          @media screen and(max-width:1024px){
            width: 80%;
            font-size: 18px;
            margin-top: 25px;
          }
          @media screen and(max-width:1005px){
            width: 90%;
            font-size: 18px;
            margin-top: 30px;
          }
          @media screen and(max-width:768px){
            width: 100%;
            font-size: 18px;
            margin-top: 27px;
          }
          @media screen and(max-width:540px){
            width: 100%;
            font-size: 12px;
            margin-top: 15px;
          }
          p{
            margin-top: 20px;
            text-align: left;
            text-indent: 2em;
            @media screen and(max-width:760px){
              margin-top: 10px;
            }
          }
        }
    }
  .map{
    width: 100%;
    height: 450px;
    padding: 0 100px;
    margin-bottom: 60px;
    .map1{
      height: 450px;
    }
    // height: 508px;
  }

  @media screen and(max-width:768px){  
    .map{
      height: 200px;
        padding: 0 20px;
    margin-bottom: 20px;
        .map1{
          height: 200px;
        }
    }
    
  }





    .shop {
      .animation-bg-view{
        margin-bottom: 60px;
        .animation {
          position: absolute;
          left: 0;
          right: 0;
          margin: auto;
          z-index: 10;
          img{
            width: 68px;
            cursor: pointer;
            border-radius: 3px;
            @media screen and(max-width: 768px){
              width: 40px;
            }
          }
        }
      }
  }
</style>
